// @flow
import React from 'react';
import YouTubePlayer from 'youtube-player';
import { Small } from '@finect/tabular-core/Small';
import { VideoBlock, VideoBlockInner, VideoPlayer, Caption } from './partials';

type Props = {
  id: string,
  src: string,
  caption?: string,
  inline?: boolean
};

export class Video extends React.Component<Props> {
  player: Object;

  componentWillUnmount() {
    this.player.destroy();
  }

  // sendGAEvent = (title: string, event: string, label?: string) => {
  //   window.ga('finecttest.send', {
  //     hitType: 'event',
  //     eventCategory: `Video: ${title}`,
  //     eventAction: event,
  //     eventLabel: label ? label : null,
  //     nonInteraction: true
  //   });
  // };

  componentDidMount() {
    this.player = YouTubePlayer(this.props.id);
    // $FlowFixMe
    /* eslint-disable */
    this.player.on('stateChange', event => {
      // const { target } = event;
      // const { title } = target.getVideoData();
      // const videoTime = target.getCurrentTime();
      // const videoLength = target.getDuration();
      // const videoProgress = Math.round((videoTime * 100) / videoLength);
      // switch (data) {
      //   case 1:
      //     return this.sendGAEvent(
      //       title,
      //       Math.floor(videoTime) ? 'Resume' : 'Play'
      //     );
      //   case 2:
      //     return this.sendGAEvent(title, 'Pause', `${videoProgress}%`);
      //   case 0:
      //     return this.sendGAEvent(title, 'End');
      //   default:
      // }
      /* eslint-enable */
    });
  }

  render() {
    const { id, src, caption, inline } = this.props;
    return (
      <VideoBlock inline={inline}>
        <VideoBlockInner>
          <VideoPlayer id={id} src={src} />
        </VideoBlockInner>

        {caption ? (
          <Caption>
            <Small>{caption}</Small>
          </Caption>
        ) : null}
      </VideoBlock>
    );
  }
}
